module.exports = __webpack_public_path__ + "static/media/audio.44e4954d.mp3";